import styled from "styled-components";

const StyleForProfilButton = styled.div`
  padding: 2%;
  background: none;
  border: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  align-self: flex-end;
`;

export default StyleForProfilButton;
